import { IPolicySearchParams } from './interface';

export const HEAD_TABLE_PROPS = [
  { id: 'id', label: 'ID', align: 'center' },
  { id: 'name', label: 'Tên quyền', align: 'center' },
  { id: 'resourceAction', label: 'Hành động', align: 'center' },
  { id: 'resource', label: 'Resource', align: 'center' },
  { id: 'type', label: 'Loại', align: 'center' },
  { id: 'actionAbility', label: 'Action Ability', align: 'center' },
  { id: 'action', label: 'Action', align: 'center' },
];

export const DEFAULT_SEARCH_VALUE: IPolicySearchParams = {
  searchText: '',
  type: '',
  actionAbility: '',
};
